module.exports = __webpack_public_path__ + "img/magazin_delo_about_us_2.d6b1c956.jpg";